import React from "react";
import type { IColumn } from "@fluentui/react";
import { displayValue } from "@/components/telemetry/common/displayValue";
import StatusCodeBadge from "@/components/telemetry/common/StatusCodeBadge";
import MethodBadge from "@/components/telemetry/common/MethodBadge";
import type { TelemetrySummary } from "@/api/telemetry";
import { TelemetrySortField } from "@/components/telemetry/search/telemetrySortField";

function getTelemetryColumns(): IColumn[] {
  return [
    {
      key: "timestamp",
      name: "Timestamp",
      fieldName: "timestamp",
      minWidth: 160,
      maxWidth: 200,
      data: TelemetrySortField.Timestamp,
      onRender: (item: TelemetrySummary) =>
        displayValue(
          item.timestamp
            ? new Date(item.timestamp).toLocaleString()
            : undefined,
        ),
    },
    {
      key: "method",
      name: "Method",
      fieldName: "method",
      minWidth: 70,
      maxWidth: 80,
      data: TelemetrySortField.Method,
      onRender: (item: TelemetrySummary) => <MethodBadge method={item.method} />,
    },
    {
      key: "path",
      name: "Path",
      fieldName: "path",
      minWidth: 200,
      data: TelemetrySortField.Path,
      onRender: (item: TelemetrySummary) => displayValue(item.path),
    },
    {
      key: "statusCode",
      name: "Status",
      fieldName: "statusCode",
      minWidth: 70,
      maxWidth: 90,
      data: TelemetrySortField.StatusCode,
      onRender: (item: TelemetrySummary) => (
        <StatusCodeBadge statusCode={item.statusCode} />
      ),
    },
    {
      key: "durationInMs",
      name: "Duration (ms)",
      fieldName: "durationInMs",
      minWidth: 80,
      maxWidth: 110,
      data: TelemetrySortField.DurationInMs,
      onRender: (item: TelemetrySummary) =>
        displayValue(item.durationInMs.toLocaleString()),
    },
    {
      key: "customerId",
      name: "Customer ID",
      fieldName: "customerId",
      minWidth: 90,
      maxWidth: 110,
      data: TelemetrySortField.CustomerId,
      onRender: (item: TelemetrySummary) => displayValue(item.customerId),
    },
    {
      key: "apiName",
      name: "API Name",
      fieldName: "apiName",
      minWidth: 100,
      maxWidth: 150,
      data: TelemetrySortField.ApiName,
      onRender: (item: TelemetrySummary) => displayValue(item.apiName),
    },
    {
      key: "clientIp",
      name: "Client IP",
      fieldName: "clientIp",
      minWidth: 110,
      maxWidth: 140,
      data: TelemetrySortField.ClientIp,
      onRender: (item: TelemetrySummary) => displayValue(item.clientIp),
    },
  ];
}

export default getTelemetryColumns;
